module.exports = __webpack_public_path__ + "img/interactive-hero-slider-lincoln.f13637f0.png";